import axios from 'axios';

const END_POINT = 'https://restcountries.eu/rest/v2/alpha/';

const getCountryInformation = country =>
    axios.get(END_POINT + country + '?fields=currencies;timezones');

export {getCountryInformation};

